import { usePlotMetricFromItem } from '../../hooks/usePlotMetric';
import { useTabContentConfig } from '../PageConfigProvider/PageConfigProvider';
import type { PositionedItem } from '../PageConfigProvider/types/item';
import { SegmentedToggle } from './SegmentedToggle';

type DisplayAsSelectorProps = {
  item: PositionedItem;
  isDisabled?: boolean;
};

export const DisplayAsSelector = ({
  item,
  isDisabled = false,
}: DisplayAsSelectorProps) => {
  const { dispatch } = useTabContentConfig();
  const metric = usePlotMetricFromItem(item);
  const id = item?.id;

  const isSegmentedHeadcountLine =
    item?.plot?.chartType === 'line' &&
    metric === 'headcount' &&
    !!item?.plot?.secondaryDimension &&
    item.plot.secondaryDimension !== 'timeseries';

  const defaultDisplayAs = isSegmentedHeadcountLine ? 'share' : 'value';
  const displayAsRaw = item?.plot?.displayAs ?? defaultDisplayAs;
  const displayAs = displayAsRaw === 'share' ? 'share' : 'value';

  const handleDisplayAsChange = (newDisplayAs: 'value' | 'share') => {
    if (id && displayAs !== newDisplayAs) {
      dispatch({
        type: 'UPDATE_ITEM_DISPLAY_AS',
        payload: { id, displayAs: newDisplayAs },
      });
    }
  };

  return (
    <SegmentedToggle
      options={[
        { value: 'value', label: 'Absolute Value' },
        { value: 'share', label: 'Percentage Share' },
      ]}
      value={displayAs}
      onChange={handleDisplayAsChange}
      isDisabled={isDisabled}
    />
  );
};
